import { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';
import { getLanguageCodeFromLanguageRegionCode } from './languageTypeModifiers';

// Cases where the Zendesk URL path component is not the 2-char language code:
const languageCodeOverrides: Partial<Record<LanguageRegionCode, string>> = {
  ['en-US']: 'en-us',
  ['en-GB']: 'en-gb',
  ['nb-NO']: 'no',
  ['pt-BR']: 'pt-br',
  ['es-MX']: 'es-419'
};

/**
 * Given a locale & article id, gets the respective help center URL.
 * See https://alltrails.atlassian.net/wiki/spaces/CS/pages/1802469395/AllTrails+Support+-+Localization+Supported+Languages
 * @param languageRegionCode `LanguageRegionCode` of the desired URL
 * @param articleId id number of the article
 * @returns full url to the article with respect to the `languageRegionCode`. If no `articleId` is given, returns support page home.
 */
const getHelpCenterUrl = (languageRegionCode: LanguageRegionCode, articleId?: number): string => {
  const locale = languageCodeOverrides[languageRegionCode] || getLanguageCodeFromLanguageRegionCode(languageRegionCode);
  const baseUrl = `https://support.alltrails.com/hc/${locale}`;
  return articleId ? `${baseUrl}/articles/${articleId}` : baseUrl;
};

export default getHelpCenterUrl;
